import { TldrawApp } from "@psi/tldraw";
import * as React from "react";

export const TldrawContext = React.createContext<TldrawApp>({} as TldrawApp);

export function useTldrawApp() {
  const context = React.useContext(TldrawContext);
  return context;
}
